import SkTechApiClient from "./base/SkTechApiClient";

export type SendBulkEmailData = {
    companyId?: number;
    toEmails: string[];
    subject: string;
    message: string;
}

export default class EmailApiClient extends SkTechApiClient {

    public sendBulkEmail = async (data: SendBulkEmailData): Promise<any> => {
        return await this.Post(`/api/Email/bulkEmail`, data)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                }
                return false;
            })
            .catch(function (error) {
                console.log(error);
                return false;
            });
    }
}